import { call, put, takeEvery, select } from 'redux-saga/effects'

import { deleteData, fetchData } from 'api/orm'
import orm from 'orm'
import Api from 'utils/api'
import * as actions from './actionTypes'

export default function* ormSaga() {
  yield takeEvery(actions.PATCH_START, patchSaga)
  yield takeEvery(actions.POST_START, postSaga)
  yield takeEvery(actions.DELETE_START, deleteSaga)
  yield takeEvery(actions.FETCH_START, fetchSaga)
}

function* deleteSaga(action) {
  const { model, pk } = action.meta
  const { postSuccessAction } = action.payload
  const { deleteSuccess, setSelection, deleteError } = orm(model)
  const { error, meta } = yield call(deleteData, model, pk)
  if (error) yield put(deleteError({ pk, error }, meta))
  else {
    yield put(deleteSuccess({ pk }))
    yield put(setSelection({}))

    if (postSuccessAction) yield call(postSuccessAction)
    // const { payload } = yield select(getLocation)
    // if (payload.pk) yield put(toList())
  }
}

function* postSaga(action) {
  const { model, pk } = action.meta
  const {
    data = {},
    onFailureAction,
    onSuccessAction,
    postSuccessAction,
    noSnackbar,
  } = action.payload
  const { pendingRequest, postSuccess, postError, getDirty, reset } = orm(model)
  const dirtyData = yield select(state => getDirty(state, { pk }))
  const patchData = { ...dirtyData, ...data }

  yield put(pendingRequest({ isPending: true }))

  const { response, error, meta } = yield Api.post([model], patchData)
  if (error) {
    if (onFailureAction) {
      yield call(onFailureAction, { message: error, type: meta.HTTPstatus })
    }

    yield put(postError({ pk, error }, meta))
  } else {
    const { id } = response

    yield put(postSuccess({ pk: id, ...response }, { ...meta, noSnackbar }))
    yield put(reset({ pk }))
    if (onSuccessAction) yield put(onSuccessAction)
    if (postSuccessAction) yield call(postSuccessAction, response)
  }

  yield put(pendingRequest({ isPending: false }))
}

function* patchSaga(action) {
  const { model, pk } = action.meta
  const {
    data = {},
    onFailureAction,
    onSuccessAction,
    postSuccessAction,
  } = action.payload
  if (pk === 'add') {
    yield postSaga(action)
    return
  }
  const { patchSuccess, patchError, getDirty } = orm(model)
  const dirtyData = yield select(state => getDirty(state, { pk }))
  const patchData = { ...dirtyData, ...data }
  const { response, error, meta } = yield Api.patch([model, pk], patchData)
  if (error) {
    if (onFailureAction) {
      yield call(onFailureAction, { message: error, type: meta.HTTPstatus })
    }

    yield put(patchError({ pk, error }, meta))
  } else {
    yield put(patchSuccess({ pk, ...response }, meta))
    if (onSuccessAction) yield put(onSuccessAction)
    if (postSuccessAction) yield call(postSuccessAction)
  }
}

function* fetchSaga(action) {
  const { model, pk } = action.meta
  const { pendingRequest, fetchSuccess, fetchError } = orm(model)

  yield put(pendingRequest({ isPending: true }))

  const { response, error, meta } = yield call(
    fetchData,
    model,
    pk,
    action.payload,
  )
  if (error) yield put(fetchError({ pk, error }, meta))
  else yield put(fetchSuccess({ pk, ...response }, meta))

  yield put(pendingRequest({ isPending: false }))
}
